import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "palette" }
const _hoisted_2 = {
  key: 1,
  class: "my-color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_palette_item = _resolveComponent("app-palette-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "palette-left",
      style: _normalizeStyle({ gap: _ctx.gap, width: _ctx.width })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.segments.slice(0, 35), (value) => {
        return (_openBlock(), _createBlock(_component_app_palette_item, {
          key: value,
          color: value.color,
          "selected-mode": _ctx.selectedMode,
          "selected-colors": _ctx.selectedColors,
          onSelectedColor: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedColor($event)))
        }, null, 8, ["color", "selected-mode", "selected-colors"]))
      }), 128))
    ], 4),
    (_ctx.item.segments.slice(35, 65).length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "palette-right",
          style: _normalizeStyle({ gap: _ctx.gap, width: _ctx.width })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.segments.slice(35, 65), (value) => {
            return (_openBlock(), _createBlock(_component_app_palette_item, {
              key: value,
              color: value.color,
              "selected-mode": _ctx.selectedMode,
              "selected-colors": _ctx.selectedColors,
              onSelectedColor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedColor($event)))
            }, null, 8, ["color", "selected-mode", "selected-colors"]))
          }), 128))
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.paletteCards.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paletteCards, (value) => {
            return (_openBlock(), _createBlock(_component_app_palette_item, {
              key: value,
              color: value.color
            }, null, 8, ["color"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}